export const AdditionalTerms = [
    "Für Mehrtagesfahrten gilt, dass im Kostenbeitrag eine Gebühr für einen Hafentag und zwei Motorstunden " +
    "pro Tag enthalten sind. Jede weitere Motorstunde wird mit 50,00€ berechnet. Die Endabrechnung erfolgt an Bord.",
    "Lebensmittel und alkoholfreie Getränke sind ab dem ersten vollen Buchungstag im Preis inbegriffen. " +
    "Die Kosten für die Verpflegung am ersten Abend trägt der/die Mitsegler*in selbst."
]